import * as Starknet from 'starknet';

export default function toIntString(hex: Starknet.num.BigNumberish) {
  return Starknet.num.toBigInt(hex).toString(10);
}
